<template>
  <div v-if="item">
    <div
      class="
        grid grid-cols-[repeat(3,auto)]
        gap-3
        justify-start justify-items-start
      "
    >
      <div>
        <img
          :src="$firstImage(item.images, 'small')"
          alt=""
          class="img my-4px w-32 h-32 object-cover"
          :onerror="defaultUrl"
        />
      </div>
      <div class="text-left space-y-3">
        <p class="font-bold space-x-2 mt-1">
          <span>{{ item.name }}</span>
        </p>
        <div class="text-sm">
          <p>{{ $p(item.price) }}</p>
          <p class="pl-1 text-gray-400">x{{ item.quantity }}</p>

          <!-- 月光漫步大花瓣10枝起购
          <br />
          买越多越省钱 -->
        </div>
      </div>
      <div class="space-x-3 mt-1 ml-10"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  props: { item: Object },
  setup() {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    return { defaultUrl };
  },
});
</script>

<style scoped lang="scss"></style>
